// src/components/OrderConfirmation.js

import React, { useEffect, useState } from "react";

const OrderConfirmation = () => {
  const [orderDetails, setOrderDetails] = useState({});

  useEffect(() => {
    //Retrieve order details from localStorage
    const storedOrderDetails = localStorage.getItem("orderDetails");
    if (storedOrderDetails) {
      setOrderDetails(JSON.parse(storedOrderDetails));
      localStorage.removeItem("orderDetails"); //Clear order details from localStorage
    }
  }, [setOrderDetails]);

  //Check if orderDetails and cart are defined and if cart is an array
  if (
    !orderDetails ||
    !orderDetails.cart ||
    !Array.isArray(orderDetails.cart)
  ) {
    return <div>No items found in the order</div>;
  }

  return (
    <div className="order-confirmation">
      <h2>Order Confirmation</h2>
      <p>Thank you for your order, {orderDetails.fullName} </p>
      <h3>Order Summary</h3>
      <p>Email: {orderDetails.email}</p>
      <p>Phone: {orderDetails.phone}</p>
      <p>Address: {orderDetails.address}</p>
      <p>City: {orderDetails.city}</p>
      <p>State: {orderDetails.state}</p>
      <p>Zip Code: {orderDetails.zip}</p>
      <h3>Items:</h3>
      <ul>
        {orderDetails.cart.map((item) => (
          <li key={item._id}>
            {item.name} - ${item.price.toFixed(2)}
          </li>
        ))}
      </ul>
      <h3>
        Total Price: $
        {orderDetails.totalPrice ? orderDetails.totalPrice.toFixed(2) : "0.00"}
      </h3>
    </div>
  );
};

export default OrderConfirmation;
